import Progress from '@/components/progress/Progress'
import StudentList from '@/components/progress/StudentList'
import StudentCourseList from '@/components/progress/StudentCourseList'
import TableOfContents from '@/components/progress/TableOfContents'
import StudentTaskList from '@/components/progress/StudentTaskList'

export default [
  {
    path: '/progress',
    component: Progress,
    children: [
      {path: '', component: StudentList},
      {path: ':uid', component: StudentCourseList},
      {path: ':uid/:progressKey', component: TableOfContents},
      {path: ':uid/:progressKey/:sectionKey', component: StudentTaskList}
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/progress/routes.js